import React, { memo, useState } from "react";

import { useStore } from "src/store";
import { useEventCb } from "src/utils";

import styles from "./style.css";

let deferredPrompt;
let externalPromptStateAsRemoved = false;

const AddToHomeScreen = memo(() => {
  const store = useStore("config");
  const { template = {} } = store("config");

  const [open, setProptVisibility] = useState(false);
  const homeScreenActive = template.homeScreen && template.homeScreen.active;

  const showPrompt = event => {
    event.preventDefault();
    deferredPrompt = event;
    if (externalPromptStateAsRemoved == false && homeScreenActive) {
      setProptVisibility(true);
    }
    return false;
  };

  useEventCb("beforeinstallprompt", showPrompt);

  const reportEvent = action => {
    if (window.gtag) {
      window.gtag("send", "event", {
        event_category: "A2HS",
        event_action: action,
        event_label: window.location.href,
        transport: "beacon"
      });
    }
  };

  const promptOk = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();

      deferredPrompt.userChoice.then(function(choiceResult) {
        if (choiceResult.outcome === "dismissed") {
          reportEvent("dialogueCancelClick");
        } else {
          reportEvent("dialogueAddClick");
        }

        externalPromptStateAsRemoved = true;
        setProptVisibility(false);
      });

      reportEvent("inlineOkayClick");
      deferredPrompt = null;
    }
  };

  const promptCancel = () => {
    reportEvent("inlineCancelClick");
    setProptVisibility(false);
  };

  return open ? (
    <div class={styles.container}>
      <p>Would you like to add this page to Home Screen?</p>
      <button onClick={promptCancel}>Cancel</button>
      <button onClick={promptOk}>Okay</button>
    </div>
  ) : null;
});

export default AddToHomeScreen;
